import React from "react";
import UseContext from "hooks/useContext";
import ActivityTemplate from "pages/jobPostTemplates/body/activity.template";
import PrerequisTemplate from "pages/jobPostTemplates/body/prerequis.template";
import LocationSalaryTemplate from "pages/jobPostTemplates/body/locationSalary.template";
import InfoTemplate from "pages/jobPostTemplates/body/info.template";
import ConfirmationTemplate from "pages/jobPostTemplates/body/confirmation.template";
import EndTemplate from "pages/jobPostTemplates/body/end.template";

const TemplateFormsCreate = ({
    mode,
    savedJobPostDoc,
    editTemplateRouteId,
}) => {
    const { templatePage } = UseContext();
    const display = {
        1: <ActivityTemplate key="activity" />,
        2: <PrerequisTemplate key="prerequis" />,
        3: <LocationSalaryTemplate key="locationSalary" />,
        4: <InfoTemplate key="info" />,
        5: <ConfirmationTemplate key="confirmation" />,
        6: (
            <EndTemplate
                key="end"
                mode={mode}
                savedJobPostDoc={savedJobPostDoc}
                editTemplateRouteId={editTemplateRouteId}
            />
        ),
    };
    return <>{display[templatePage]}</>;
};

export default TemplateFormsCreate;
